import { BlocklistsModel } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

const api = new RequestCreator<BlocklistsModel>('/ipad/blocklists');
export default api;
